import { Select, SelectProps } from "@mantine/core";
import useQueryTipoDeJogadaSelector from "./useGetTipoDeJogada";

interface Tipo {
  nome?: string;
  id?: string;
}

const TipoDeJogadaSelector = (properties: SelectProps) => {
  const { data, isLoading, error } = useQueryTipoDeJogadaSelector();
  const formatData = data?.map((item: Tipo) => ({
    value: item.id || "",
    label: item.nome || ""
  }));

  return <Select data={formatData} disabled={isLoading} error={error?.message} {...properties} />;
};

export default TipoDeJogadaSelector;
